import { render, staticRenderFns } from "./LmComments.vue?vue&type=template&id=27f53166&"
import script from "./LmComments.vue?vue&type=script&lang=js&"
export * from "./LmComments.vue?vue&type=script&lang=js&"
import style0 from "./LmComments.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports